import { useEffect, useState } from "react";
import { Div, Text } from "view/lib/components";

const Blog = () => {
  const [text, setText] = useState("");
  
  const getFile = async () => {
    const response = await fetch(`${process.env.PUBLIC_URL}/blogs/Truth is Not a Jigsaw Puzzle.txt`);

    setText(await response.text());
  }

  useEffect(() => {getFile()}, []);
  return <Div style={styles.container}>
    <Text style={styles.title}>Truth is Not a Jigsaw Puzzle</Text>
    <div dangerouslySetInnerHTML={{__html: text}} />
  </Div>;
}

const styles = {
  container: {
    padding: "1%"
  },
  title: {
    fontSize: "xx-large"
  }
}

export default Blog;